// @ts-nocheck

import React, { useContext } from 'react';
import { Group, Image } from 'react-konva';

import Formatter from '../../../i18n/formatter';
import { getCurrency } from '../../../i18n/l10n';
import BetshareContext from '../contexts/BetshareContext';
import { getRelativeValue } from '../utils';

import ScalableText from './ScalableText';

const BonusArea = (props) => {
  const { x, y, bonus, boosterPercent, promotionTitle, isSystem, forwardRef } = props;
  const {
    images: { bannerBonus, combobooster },
    stageWidth,
  } = useContext(BetshareContext);
  const currency = getCurrency();

  return (
    <Group x={x} y={y} ref={forwardRef}>
      <Image
        image={bannerBonus}
        x={0}
        y={0}
        width={getRelativeValue(400, stageWidth)}
        height={getRelativeValue(18, stageWidth)}
      />
      {combobooster ? (
        <Image
          image={combobooster}
          x={getRelativeValue(isSystem ? 220 : 190, stageWidth)}
          y={getRelativeValue(4, stageWidth)}
          width={getRelativeValue(79, stageWidth)}
          height={getRelativeValue(9, stageWidth)}
        />
      ) : (
        <ScalableText
          text={promotionTitle}
          fontSize={getRelativeValue(10, stageWidth)}
          lineHeight={1.2}
          fontFamily="BettingPoliticaExtraBold, sans-serif"
          x={getRelativeValue(13, stageWidth)}
          y={getRelativeValue(0, stageWidth)}
          width={getRelativeValue(boosterPercent !== null ? 254 : 276, stageWidth)}
          height={getRelativeValue(18, stageWidth)}
          align="right"
          fill="#fff"
          verticalAlign="middle"
          shadowColor="rgba(0,0,0,0.7)"
          shadowOffsetX={getRelativeValue(1, stageWidth)}
          shadowOffsetY={getRelativeValue(1, stageWidth)}
        />
      )}
      {boosterPercent !== null && (
        <ScalableText
          text={Formatter.formatPercent(boosterPercent)}
          fontSize={getRelativeValue(10, stageWidth)}
          lineHeight={1.2}
          fontFamily="BettingPoliticaExtraBoldItalic, sans-serif"
          x={getRelativeValue(275, stageWidth)}
          y={getRelativeValue(0, stageWidth)}
          width={getRelativeValue(30, stageWidth)}
          height={getRelativeValue(18, stageWidth)}
          align="left"
          fill="#fff"
          verticalAlign="middle"
          shadowColor="rgba(0,0,0,0.7)"
          shadowOffsetX={getRelativeValue(1, stageWidth)}
          shadowOffsetY={getRelativeValue(1, stageWidth)}
        />
      )}
      <ScalableText
        text={Formatter.formatNumber(bonus, currency)}
        fontSize={getRelativeValue(10, stageWidth)}
        lineHeight={1.2}
        fontFamily="BettingPoliticaExtraBold, sans-serif"
        x={getRelativeValue(325, stageWidth)}
        y={getRelativeValue(0, stageWidth)}
        width={getRelativeValue(70, stageWidth)}
        height={getRelativeValue(18, stageWidth)}
        align="right"
        fill="#fff"
        verticalAlign="middle"
        shadowColor="rgba(0,0,0,0.7)"
        shadowOffsetX={getRelativeValue(1, stageWidth)}
        shadowOffsetY={getRelativeValue(1, stageWidth)}
      />
    </Group>
  );
};

export default BonusArea;
